<template>
  <div>
    <v-card height="428px" class="pt-1" flat>
      <v-card class="mx-auto" width="340px" shaped>
        <div style="background-color: #FAFAFA">
          <img v-if="itemMostrarDetalhes.emotion_feedback_cliente === '1'" class="fs-img-feedback" :src="require('@/assets/temp3.svg')">
          <img v-if="itemMostrarDetalhes.emotion_feedback_cliente === '2'" class="fs-img-feedback" :src="require('@/assets/temp2.svg')">
          <img v-if="itemMostrarDetalhes.emotion_feedback_cliente === '3'" class="fs-img-feedback" :src="require('@/assets/temp1.svg')">
        </div>

        <v-card-title>
          Feedback do Cliente:
        </v-card-title>

        <v-card-subtitle>
          {{ itemMostrarDetalhes.emotion_feedback_cliente_comentario }}
        </v-card-subtitle>
      </v-card>
      <v-card-actions class="mb-n1" style="padding: 0px; position: absolute; bottom: 0; right: 0">
        <v-btn color="warning" @click="fecharDialog()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { get } from '@/api/crud'

export default {
  props: {
    itemMostrarDetalhes: Object,
    fecharDialog: Function
  },
  data () {
    return {
      urlImpressao: `${process.env.VUE_APP_BASE_URL}/site/orcamentoimprimir/${this.itemMostrarDetalhes.hash}`
    }
  },
  mounted () {
    this.loadPedido()
  },
  methods: {
    async loadPedido () {
      const data = await get('/site/orcamentoimprimircrm', {}, this.itemMostrarDetalhes.id)
      document.getElementById('fs-html-pedido').innerHTML = data
    }
  }
}
</script>

<style scoped>
  .fs-img-feedback {
    max-width: 105px;
    margin-left: 120px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
